import TimelineFeedCont from 'components/Common/TimelineFeed/TimelineFeedCont'
import useFetch from 'elements/Hooks/useFetch'
import React, { Fragment } from 'react'
import { Breadcrumb, Card, Col, Popconfirm, Row, Tabs } from 'antd'
import style from '../../../../components/Sales/style.css'
import { idMaker, strVal } from '../../../../modules/Utils'
import _, { get, isEmpty } from 'lodash'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import CodeIcon from '../../../../elements/CodeIcon'
import RFQForm from '../../../../components/Purchasing/RFQ/RFQForm'
import RFQLinesCont from '../../../../components/Purchasing/RFQ/Lines/RFQLinesCont'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import { streamUrl } from '../../../../variables'
import IconText from '../../../../elements/IconText'
import Authentication from '../../../../modules/Authentication'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import EmailListCont from '../../../../components/Main/Emails/EmailCont'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { RFQApi } from '../../../../api/Sales/RFQ'
import VendorQuotesList from '../../../../components/Purchasing/VendorQuotes/List'
import LinkHeader from '../../../../elements/LinkHeader'

const ids = idMaker()

AddRFQ.propTypes = {}
const auth = new Authentication()

function AddRFQ(props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    rfq,
    remove,
    removing,
    isRemovable,
    isQuoted,
    isUpdatable,
    actions,
    handleActions,
    isConfirmed,
    isIssued,
    onShowEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
  } = props

  const { data: listVendorQuotes, fetching: fetchingVendorQuotes, fetch: fetchVendorQuotes } = useFetch({
    url: `rfq/${rfq._key}/vendorQuotes`,
    dontFetch: rfq._key === undefined,
  })

  const isNew = type === 'new'
  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
      isUpdatable={isUpdatable}
      isRemovable={isRemovable}
    />
  )
  const Operations = ({ rfq, ...rest }) => {
    const ops = actions
      .filter((a) => !['update', 'remove', 'cancel'].includes(a.key))
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && !isIssued) {
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${rfq._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
    }
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }
    if (ops.length > 0 && isIssued) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Re Send Email'} type={'mail'} />
        </a>
      )
    }
    if (!!actions.find((a) => a.key === 'cancel') || rfq.status === 'Cancelled') {
      ops.push(
        <a
          onClick={() => {
            onShowEmail()
            handleActions('cancel')
          }}>
          <IconText
            text={rfq.status === 'Cancelled' ? 'Send Withdraw RFQ Email' : 'Cancel (Withdraw RFQ)'}
            type={'mail'}
          />
        </a>
      )
    }
    if (ops.length > 0 && (isConfirmed || isIssued || isQuoted)) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={'RFQ'}
        link={{
          pathname: `/clients/enquiries/${_.get(rfq, 'enquiry._id', '').replace('activities/', '')}/update`,
        }}
        code={_.get(rfq, 'enquiry.code')}
        name={_.get(rfq, 'enquiry.title')}
        visible={!_.isEmpty(_.get(rfq, 'enquiry'))}
      />
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/rfq`}>RFQ</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New RFQ' : rfq.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New RFQ</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(rfq, 'code')} title={'DWG Code'} />
                  <Status value={strVal(rfq, 'status')} />
                  <Operations style={{ marginTop: '10px' }} rfq={rfq} status={strVal(rfq, 'status')} />
                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            {isUpdatable && <SubmitButton />}
            <Row>
              <RFQForm ref={formRef} {...props} />
            </Row>
            {isUpdatable && <SubmitButton />}
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab={'RFQ Lines'} key="#lines">
            <RFQLinesCont rfq={rfq} isUpdatable={isUpdatable} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab={'Vendor Quotes'} key="#vendor-quotes">
            <VendorQuotesList
              vendorID={get(rfq, 'vendor._id')}
              rfqID={rfq._id}
              fetching={fetchingVendorQuotes}
              fetch={fetchVendorQuotes}
              list={listVendorQuotes}
              hideCompany={true}
            />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={type !== 'edit'} tab="Email" key="email">
            <EmailListCont owner={rfq._id} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="Documents" key="files">
            <Documents key={rfq._rev} editable={true} footer={false} category={false} email={true} owner={rfq} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="Notes" key="notes">
            <TimelineFeedCont {...{ owner: rfq._id, hideNotification: true }} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={rfq} key={rfq._rev} isArray={true} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddRFQ
